if (!customElements.get('ecom-cart-variant')) customElements.define('ecom-cart-variant', class extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true; this.hidden = false;
    this.button = this.querySelector('[data-variant-apply]');
    this.button.addEventListener('click', () => this.replaceVariant());
  }
  async readCart() {
    const response = await fetch(this.dataset.cartUrl + '.js', {headers: {Accept: 'application/json'}, cache: 'no-store'});
    if (!response.ok) throw new Error(this.dataset.error);
    return response.json();
  }
  async replaceVariant() {
    const target = Number(this.querySelector('[data-variant-select]').value);
    if (this.busy || target === Number(this.dataset.variant)) return;
    const form = this.closest('form');
    if (form.dataset.busy) return;
    if ([...form.querySelectorAll('input[data-key]')].some(input => input.value !== input.defaultValue)) {
      this.querySelector('[data-variant-status]').textContent = this.dataset.conflict; return;
    }
    this.busy = true; form.dataset.busy = 'true'; form.setAttribute('aria-busy', 'true');
    const express = form.querySelector('.ecom-express');
    const expressWasInert = express?.inert;
    if (express) express.inert = true;
    const controls = [...form.querySelectorAll('button,input,select')];
    const disabled = controls.map(control => control.disabled);
    controls.forEach(control => control.disabled = true);
    const status = this.querySelector('[data-variant-status]');
    status.textContent = this.dataset.loading; this.setAttribute('aria-busy', 'true');
    let added = false;
    try {
      const before = await this.readCart();
      const original = before.items.find(item => item.key === this.dataset.key);
      if (!original || original.quantity !== Number(this.dataset.quantity) || original.selling_plan_allocation || Object.keys(original.properties || {}).length) throw new Error(this.dataset.conflict);
      const targetQuantity = cart => {
        const quantity = cart.items.filter(item => item.variant_id === target && !item.selling_plan_allocation && !Object.keys(item.properties || {}).length).reduce((total,item) => total + item.quantity, 0);
        return Number.isSafeInteger(quantity) && quantity >= 0 ? quantity : -1;
      };
      const expectedTargetQuantity = targetQuantity(before) + original.quantity;
      if (!Number.isSafeInteger(expectedTargetQuantity) || expectedTargetQuantity < original.quantity) throw new Error(this.dataset.conflict);
      const add = await fetch(this.dataset.cartUrl + '/add.js', {method:'POST', headers: {'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({items:[{id:target, quantity:original.quantity}]})});
      if (!add.ok) throw new Error(this.dataset.error);
      added = true;
      const after = await this.readCart();
      const oldLines = after.items.filter(item => item.variant_id === original.variant_id && !item.selling_plan_allocation && !Object.keys(item.properties || {}).length);
      if (oldLines.length !== 1 || oldLines[0].quantity !== original.quantity || targetQuantity(after) < expectedTargetQuantity) throw new Error(this.dataset.partial);
      const remove = await fetch(this.dataset.cartUrl + '/change.js', {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({id:oldLines[0].key, quantity:0})});
      if (!remove.ok) throw new Error(this.dataset.partial);
      const result = await remove.json();
      if (result.items.some(item => item.key === oldLines[0].key) || targetQuantity(result) < expectedTargetQuantity) throw new Error(this.dataset.partial);
      location.assign(this.dataset.cartUrl + '?view=ecom');
    } catch (error) {
      status.textContent = added ? this.dataset.partial : error.message || this.dataset.error;
      this.querySelector('[data-variant-review]').hidden = false;
      this.button.disabled = true;
      controls.forEach((control,index) => { if (control !== this.button) control.disabled = disabled[index]; });
      if (express) express.inert = expressWasInert;
      delete form.dataset.busy; form.removeAttribute('aria-busy'); this.removeAttribute('aria-busy');
    }
  }
});
